import React from "react";

function ScoreButton({ actionType, setAndPlayer, onClick, scoreId }) {
  const btnId = scoreId ? scoreId : `${actionType}${setAndPlayer}`;

  return (
    <button
      onClick={(e) => onClick(e)}
      type="div"
      id={btnId}
      className="increment-btn"
      data-action={actionType}
      data-setandplayer={scoreId ? btnId : setAndPlayer}
    >
      {actionType === "increment" ? "+" : "-"}
    </button>
  );
}

export default ScoreButton;
